import { render, staticRenderFns } from "./BaseQuillEditor.vue?vue&type=template&id=005ef3e0"
import script from "./BaseQuillEditor.vue?vue&type=script&lang=ts"
export * from "./BaseQuillEditor.vue?vue&type=script&lang=ts"
import style0 from "./BaseQuillEditor.vue?vue&type=style&index=0&id=005ef3e0&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports